import { useEffect, useState } from "react";
import { getGeoLocationByIpAddress } from "../services/weatherAndLocationService";

const useDeviceLocation = (baseUrl: string) => {
  const [lat, setLat] = useState<number | undefined>();
  const [long, setLong] = useState<number | undefined>();
  const [isLoading, setIsLoading] = useState(false);
  const [errMsg, setErrMsg] = useState<string | null>(null);
  const [city, setCity] = useState<string | undefined>();
  const [country, setCountry] = useState<string | undefined>();

  const fetchGeoLocationByIpAddress = (baseUrl: string) => {
    getGeoLocationByIpAddress(baseUrl)
      .then((geoLocation) => {
        setLat(geoLocation.latitude ?? undefined);
        setLong(geoLocation.longitude ?? undefined);
        setCity(geoLocation.city ?? undefined);
        setCountry(geoLocation.country_name ?? undefined);
        setErrMsg(null);
      })
      .catch((err) => {
        setErrMsg('Unable to retrieve your location');
      });
  }


  useEffect(() => {
    try {
      setIsLoading(true);
      fetchGeoLocationByIpAddress(baseUrl);
      // If we can get device's GPS location, we use it
      // otherwise we will just use the location that came from the IP
      if (!navigator.geolocation) {
        console.error("Geolocation is not supported by your browser");
        setErrMsg("Geolocation is not supported by your browser");
      }
      else {
        navigator.geolocation.getCurrentPosition((position) => {
          setLat(position.coords.latitude);
          setLong(position.coords.longitude);
        }, () => {
          console.error("Unable to retrieve your location");
          setErrMsg("Unable to retrieve your location");
        });
      }
    }
    finally {
      setIsLoading(false);
    }
  }, [baseUrl]);

  return { lat, long, city, country, isLoading, errMsg };
}

export default useDeviceLocation;